export default __webpack_public_path__ + "static/media/ReactReveal&Skeleton.92fbab32.png";